import PropTypes from 'prop-types'

import { idPropType } from '../../common/prop-types'

const dishIngredientPropType = PropTypes.shape({
  ingredient: PropTypes.shape({
    id: idPropType.isRequired,
    name: PropTypes.string,
    isCurationEnabled: PropTypes.bool,
  }),
  isSuggestedByAi: PropTypes.bool,
  originField: PropTypes.string,
  word: PropTypes.string,
  matchType: PropTypes.string,
  alternativeType: PropTypes.string,
  overrides: PropTypes.arrayOf(
    PropTypes.shape({
      word: PropTypes.string,
      originField: PropTypes.string,
      matchType: PropTypes.string,
      usedFeature: PropTypes.string,
      posIndex: PropTypes.arrayOf(PropTypes.number),
    }),
  ),
  alreadyFoundIn: PropTypes.arrayOf(
    PropTypes.shape({
      word: PropTypes.string,
      originField: PropTypes.string,
      matchType: PropTypes.string,
      usedFeature: PropTypes.string,
      posIndex: PropTypes.arrayOf(PropTypes.number),
    }),
  ),
  replacesIngredientId: idPropType,
  usedFeature: PropTypes.string,
  posIndex: PropTypes.arrayOf(PropTypes.number),
  isSuggestedUsingMl: PropTypes.bool,
  isSuggestedUsingParser: PropTypes.bool,
  mlScore: PropTypes.number,
  keyword: PropTypes.string,
  isDiscrepancyAccepted: PropTypes.bool,
})

export default dishIngredientPropType
